module.exports = __webpack_public_path__ + "media/images/recipes/vega_braadworst-d8a7fd1b67987519a49bf3c7ed14b356.pdf";